import React, { useEffect, useRef, useState } from "react";
import PropTypes from 'prop-types';

import { Box, Typography } from "@mui/material";

import MaskSelectorToolStyles from "./MaskSelectorToolStyles";

const StepTitle = ({ title }) => {

  const topRef = useRef(null);
  const [firstRender, setFirstRender] = useState(true);

  useEffect(() => {
    if(topRef?.current && firstRender) {
      topRef.current.focus();
      setFirstRender(false);
    }
  }, [topRef, firstRender]);

  const {classes} = MaskSelectorToolStyles();

  return (
    <Box display="flex" mb={1}>
      <Typography className={`${classes.noOutline} ${classes.res_survey_header}`} variant="h5" tabIndex="0" aria-label={title} ref={topRef} >{title}</Typography>
    </Box>
  );
};
StepTitle.propTypes = {
  title: PropTypes.string.isRequired
}

export default StepTitle;
